import { ActionTree } from 'vuex'
import { State as RootState } from '@/store/state'

import { Vehicles } from './state'

const actions: ActionTree<Vehicles, RootState> = {}

export default actions
